import { Injectable } from '@angular/core';
import { XsHttpApiService } from 'src/app/common/services/xs-http-api.service';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';
import { PlusdCommonService } from './plusd-common.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(
    public xsHttpApiService: XsHttpApiService,
    public xsAppConfigService: XsAppConfigService,
    public plusdCommonService: PlusdCommonService,
    private cookieService: CookieService
  ) { }

  /*inicializar(parametro): any {
    parametro.idUsuario = this.cookieService.get("idUsuario");
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/inicializar",
      parametro
    );
  }

  listar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/listar",
      parametro
    );
  }

  agregar(parametro): any {
    parametro.audCreadoPor = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/agregar",
      parametro
    );
  }

  modificar(parametro): any {
    parametro.audModificadoPor = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/modificar",
      parametro
    );
  }

  eliminar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/eliminar",
      parametro
    );
  }

  modificarOpcionEstado(parametro): any {
    parametro.audModificadoPor = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/modificar-estado-opcion",
      parametro
    );
  }

  obtenerAdministrado(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/obtener-administrado",
      parametro
    );
  }

  listarOpciones(parametro): any {
    parametro.idUsuarioPrincipal = this.cookieService.get("idUsuario");
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/listar-opciones",
      parametro
    );
  }

  listarOpcionesSSO(parametro): any {
    parametro.idUsuario = this.cookieService.get("idUsuario");
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/listar-opcionessso",
      parametro
    );
  }

  obtenerEstadoClave(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/obtener-estado-clave",
      parametro
    );
  }

  mensaje(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/usuario/mensaje",
      parametro
    );
  }

  usuarioExistente(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/solicitud/consultar-usuario-existente",
      parametro
    );
  }*/
}
